import { Icon, type TIconProps } from '~/components/icon'

interface TModalIconProps
  extends Omit<TIconProps, 'symbol' | 'size' | 'color'> {
  symbol?: TIconProps['symbol']
  color?: TIconProps['color']
}

export function ModalIcon({ symbol, color, ...rest }: TModalIconProps) {
  return <Icon {...rest} size="small" symbol={symbol} color={color} />
}
